"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomerProfileView_1 = __importDefault(require("./CustomerProfileView"));
exports.default = CustomerProfileView_1.default;
